import { FormField, InputSelectField } from '@tempmee/react';
import { forwardRef, memo, type Ref, useMemo } from 'react';

interface IProfessionalTypeFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  professionOptions: { code: string; name: string }[];
  hasError?: boolean;
}

const Component = (
  { value, onChange, professionOptions, hasError }: IProfessionalTypeFieldProps,
  ref: Ref<HTMLDivElement>,
) => {
  const options = useMemo(
    () => professionOptions.map((o) => ({ label: o.name, value: o.name })),
    [professionOptions],
  );

  return (
    <div ref={ref} data-testid="professional-type-field" data-cy="professional-type-field">
      <FormField label="Professional Type">
        <InputSelectField<string>
          options={options}
          value={value || undefined}
          onChange={onChange}
          placeholder="Select Type"
          isError={Boolean(hasError)}
        />
      </FormField>
    </div>
  );
};

export const ProfessionalTypeField = memo(forwardRef(Component));
